import React, { useCallback } from "react";

import Tag from "antd/es/tag";
import { FormattedMessage, useIntl } from "react-intl";

import UserRef from "@mapmycustomers/shared/types/User";
import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";
import { Avatar, Button, Modal } from "@mapmycustomers/ui";

import EditProfilePhoto from "@app/component/EditProfilePhoto";
import navbarAnalytics from "@app/util/analytic/navbarAnalytics";

import styles from "./UserProfileInfo.module.scss";

interface Props {
  user: UserRef;
}

const UserProfileInfo = ({ user }: Props) => {
  const intl = useIntl();
  const [isEditProfilePhotoModalVisible, showEditProfilePhotoModal, hideEditProfilePhotoModal] =
    useBoolean();

  const handleAvatarClick = useCallback(() => {
    showEditProfilePhotoModal();
    navbarAnalytics.clicked(["Profile Picture"]);
  }, [showEditProfilePhotoModal]);

  return (
    <div className={styles.userProfile}>
      <div className={styles.userAvatar}>
        <Avatar tooltip={false} user={user} />
        <div className={styles.userProfileOverlay} onClick={handleAvatarClick}>
          <FormattedMessage
            id="navbar.userMenu.editProfilePhoto.overlay"
            defaultMessage="Edit"
            description="Action name in the profile photo overlay inside the user menu."
          />
        </div>
      </div>

      <section className={styles.userDetails}>
        <div className={styles.name}>{user.fullName}</div>
        <div className={styles.email}>{user.username}</div>
        <Tag className={styles.role}>{user.role.name}</Tag>
      </section>

      <Modal
        footer={
          <Button onClick={hideEditProfilePhotoModal}>
            <FormattedMessage
              id="navbar.userMenu.editProfilePhoto.modal.close"
              defaultMessage="Close"
              description="Close button title in the edit profile photo modal."
            />
          </Button>
        }
        onCancel={hideEditProfilePhotoModal}
        title={intl.formatMessage({
          id: "navbar.userMenu.editProfilePhoto.modal",
          defaultMessage: "Edit Profile Photo",
          description: "Title of the edit profile photo modal.",
        })}
        visible={isEditProfilePhotoModalVisible}
      >
        <div className={styles.editProfilePhotoModalContainer}>
          <EditProfilePhoto user={user} />
        </div>
      </Modal>
    </div>
  );
};

export default UserProfileInfo;
